<template>
    <v-dialog
      v-model="openDialog"
      width="500">
      <template v-slot:activator="{ on }">
        <v-btn
          color="red lighten-2"
          dark
          v-on="on">
          Take Picture
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          Take Picture
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
            <video ref="player" width="100%" height="100%" autoplay/>
            <canvas ref="canvas" width="100%" height="100%" hidden />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onTakePictureBtnClick">
            Take Picture
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data () {
            return {
                openDialog: false
            }
        },
        methods: {
        requestForCameraAccess () {
            if( !navigator || !navigator.mediaDevices){
                return
            }

            if(!navigator.mediaDevices.getUserMedia){
                return
            }

            const constraints = {
                video: true
            }

            navigator.mediaDevices.getUserMedia(constraints)
            .then((stream) => {
                const { player } = this.$refs || {}

                if(player){
                    player.srcObject  = stream
                }
            })
            .catch(e => {
                console.log(e)
            })
          },
          onTakePictureBtnClick () {
              this.takePicture()
              this.openDialog = false
              this.stopTrack()
          },
          takePicture () {
              const { player, canvas } = this.$refs || {}
              
              if(!player || !canvas){
                return
              }

              const  context = canvas.getContext('2d')
              canvas.width = player.width;
              canvas.height = player.height;
              context.drawImage(player, 0, 0, player.width, player.height);
    
              var data = canvas.toDataURL('image/png');
            //   photo.setAttribute('src', data);
            this.$emit('img-captured', data)
          },
          stopTrack () {
              const { player } = this.$refs || {}
              
              if(!player){
                  return
              }
              
            const videoTrack = player.srcObject.getVideoTracks()
            // Stop Track
            
            if(videoTrack){
                videoTrack.forEach(track => track.stop())
            }
          }
        },
        watch: {
            openDialog (newValue) {
                if(newValue){
                    this.requestForCameraAccess()
                }
            }
        }
    }
</script>

<style scoped>
/*remove mirror effect from video but not remove mirrr effect from the captured image */
/* video {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
} */
</style>